export default __webpack_public_path__ + "static/media/appLogoMobile.d69069d8.svg";